module.exports = __webpack_public_path__ + "img/person.c93b68d4.png";